<template>
  <v-hover v-slot="{ hover }">
    <v-card :elevation="hover ? 5 : 0" class="container-item" @click="removerFiltro">
      <div class="container-paciente-evento">
        <div class="selecionado-label">
          <span class="primary--text" style="font-size: 14px">Nome</span>
          <p>{{ pacienteSelecionado.nome }}</p>
        </div>
        <div class="selecionado-label ml-5">
          <span class="primary--text" style="font-size: 14px">Sexo</span>
          <p>{{ pacienteSelecionado.sexo }}</p>
        </div>
      </div>
      <v-overlay :value="hover" absolute>
        <div>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon>
                <v-icon size="30">mdi-close-circle</v-icon>
              </v-btn>
            </template>
            Remover filtro
          </v-tooltip>
        </div>
      </v-overlay>
    </v-card>
  </v-hover>
</template>

<script>
export default {
    name: 'CardPacienteSelecionado',
    props: {
        pacienteSelecionado: {
            type: Object,
            required: true
        },
    },
    methods: {
        removerFiltro() {
            this.$emit('removerFiltroPaciente')
        }
    }
}
</script>

<style scoped lang="stylus">

.container-paciente-evento
  background-color #E0E0E0
  height 65px
  padding 10px
  font-size 16px
  border-radius 5px
  display flex

.selecionado-label
  font-weight bold

  p
    color #5a5a5a

</style>